(function () {
  'use strict';

  function formatMoney(cents) {
    return 'R$\u00a0' + (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function shopifyImgUrl(src, width) {
    if (!src) return '';
    return src.replace(/(_\d+x\d*|_\d*x\d+)(\.(?:jpg|jpeg|gif|png|webp))/i, '$2')
      .replace(/(\.(?:jpg|jpeg|gif|png|webp))/i, '_' + width + 'x$1');
  }

  function initCustomDropdowns(root) {
    root.querySelectorAll('[data-ec-variant-button]').forEach(function (btn) {
      if (btn.dataset.ecVariantInited) return;
      btn.dataset.ecVariantInited = '1';

      var ctrl = btn.closest('[data-ec-variant-control]');
      if (!ctrl) return;
      var listbox = ctrl.querySelector('[data-ec-variant-listbox]');
      var nativeSelect = ctrl.querySelector('[data-product-card-variant-select]');
      var valueEl = btn.querySelector('[data-ec-variant-value]');
      if (!listbox) return;

      function closeAll(except) {
        document.querySelectorAll('[data-ec-variant-listbox]:not([hidden])').forEach(function (lb) {
          if (lb === except) return;
          lb.hidden = true;
          var b = lb.closest('[data-ec-variant-control]').querySelector('[data-ec-variant-button]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        closeAll(isOpen ? null : listbox);
        listbox.hidden = isOpen;
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (!isOpen) {
          var selected = listbox.querySelector('.ec-variant-option--selected') || listbox.querySelector('[data-ec-variant-option]');
          if (selected) selected.focus();
        }
      });

      listbox.querySelectorAll('[data-ec-variant-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          selectOption(opt);
        });
      });

      function selectOption(opt) {
        var val = opt.dataset.value;
        listbox.querySelectorAll('[data-ec-variant-option]').forEach(function (o) {
          var sel = o === opt;
          o.classList.toggle('ec-variant-option--selected', sel);
          o.setAttribute('aria-selected', String(sel));
        });
        if (valueEl) valueEl.textContent = val;
        if (nativeSelect) {
          nativeSelect.value = val;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        listbox.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }

      btn.addEventListener('keydown', function (e) {
        var opts = Array.from(listbox.querySelectorAll('[data-ec-variant-option]'));
        var cur = listbox.querySelector('.ec-variant-option--selected') || opts[0];
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          if (listbox.hidden) { listbox.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
          var idx = opts.indexOf(cur);
          var next = e.key === 'ArrowDown' ? opts[idx + 1] || opts[0] : opts[idx - 1] || opts[opts.length - 1];
          if (next) next.focus();
        } else if (e.key === 'Escape') {
          listbox.hidden = true; btn.setAttribute('aria-expanded', 'false');
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          listbox.hidden = !listbox.hidden;
          btn.setAttribute('aria-expanded', String(!listbox.hidden));
        }
      });

      listbox.addEventListener('keydown', function (e) {
        var opts = Array.from(listbox.querySelectorAll('[data-ec-variant-option]'));
        var idx = opts.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (opts[idx + 1] || opts[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[idx - 1] || opts[opts.length - 1]).focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (idx >= 0) selectOption(opts[idx]); }
        else if (e.key === 'Escape') { listbox.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
        else if (e.key === 'Tab') { listbox.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
      });
    });

    if (!document._ecVariantOutside) {
      document._ecVariantOutside = true;
      document.addEventListener('click', function () {
        document.querySelectorAll('[data-ec-variant-listbox]:not([hidden])').forEach(function (lb) {
          lb.hidden = true;
          var b = lb.closest('[data-ec-variant-control]').querySelector('[data-ec-variant-button]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  function initVariantSelects(bundle) {
    bundle.querySelectorAll('[data-product-card-variant]').forEach(function (card) {
      if (card.dataset.bundleVariantInited) return;
      card.dataset.bundleVariantInited = '1';

      var productId = card.getAttribute('data-product-id');
      if (!productId) return;

      var selects = card.querySelectorAll('[data-product-card-variant-select]');
      var hiddenInput = card.querySelector('[data-product-card-variant-id]');
      var availabilityEl = card.querySelector('[data-product-card-variant-availability]');
      if (!selects.length || !hiddenInput) return;

      var productJsonEl = document.getElementById('BundleProductJson-' + productId);
      if (!productJsonEl) return;

      var productData;
      try { productData = JSON.parse(productJsonEl.textContent || '{}'); }
      catch (e) { console.error('[ec-bundle] JSON parse error', e); return; }

      function getSelectedOptions() {
        return Array.from(selects).map(function (s) { return s.value; });
      }

      function findVariant(opts) {
        return (productData.variants || []).find(function (v) {
          return v.options && opts.every(function (val, i) { return v.options[i] === val; });
        }) || null;
      }

      function updateVariant() {
        var matched = findVariant(getSelectedOptions());
        if (!matched) { if (availabilityEl) availabilityEl.hidden = false; return; }

        hiddenInput.value = matched.id;
        if (availabilityEl) availabilityEl.hidden = matched.available;

        card.dispatchEvent(new CustomEvent('bundle:variant:changed', {
          bubbles: true,
          detail: {
            productId: productId,
            variantId: matched.id,
            price: matched.price,
            compareAtPrice: matched.compare_at_price,
            available: matched.available,
            featuredImage: matched.featured_image || null,
            images: productData.images || []
          }
        }));
      }

      selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
      updateVariant();
    });
  }

  function updateCardUI(item, detail) {
    var priceCurrentEl = item.querySelector('[data-bundle-price-current]');
    var priceCompareEl = item.querySelector('[data-bundle-price-compare]');

    if (priceCurrentEl) {
      priceCurrentEl.textContent = formatMoney(detail.price);
    }
    if (priceCompareEl) {
      if (detail.compareAtPrice && detail.compareAtPrice > detail.price) {
        priceCompareEl.textContent = formatMoney(detail.compareAtPrice);
        priceCompareEl.style.display = '';
      } else {
        priceCompareEl.style.display = 'none';
      }
    }

    var imgEl = item.querySelector('[data-bundle-img]');
    if (!imgEl) return;

    var newSrc = null;

    if (detail.featuredImage && detail.featuredImage.src) {
      newSrc = detail.featuredImage.src;
    } else if (detail.images && detail.images.length > 0) {
      newSrc = detail.images[0].src || (detail.images[0].url || '');
    }

    if (newSrc) {
      var src160 = shopifyImgUrl(newSrc, 160);
      var src320 = shopifyImgUrl(newSrc, 320);
      var src600 = shopifyImgUrl(newSrc, 600);
      imgEl.src = src600;
      imgEl.srcset = src160 + ' 160w, ' + src320 + ' 320w, ' + src600 + ' 600w';
    }
  }

  function initBundleSummary(bundle) {
    if (bundle.dataset.bundleSummaryInited) return;
    bundle.dataset.bundleSummaryInited = '1';

    var items = bundle.querySelectorAll('[data-bundle-item]');
    var totalAmountEl = bundle.querySelector('[data-bundle-total-amount]');
    var compareWrapEl = bundle.querySelector('[data-bundle-compare-price]');
    var compareAmountEl = bundle.querySelector('[data-bundle-compare-amount]');
    var installmentsWrapEl = bundle.querySelector('[data-bundle-installments]');
    var installmentsTextEl = bundle.querySelector('[data-bundle-installments-text]');
    var addToCartBtn = bundle.querySelector('[data-bundle-add-to-cart]');
    var unavailableNotice = bundle.querySelector('[data-bundle-unavailable]');

    var maxInstallments = parseInt(bundle.dataset.installmentsCount || '6', 10);
    var minInstallmentPrice = parseInt(bundle.dataset.installmentsMinPrice || '1000', 10);

    var itemState = {};
    items.forEach(function (item) {
      var pid = item.dataset.productId;
      var hiddenId = item.querySelector('[data-product-card-variant-id]');
      itemState[pid] = {
        variantId: hiddenId ? hiddenId.value : null,
        price: parseInt(item.dataset.variantPrice || '0', 10),
        compareAt: parseInt(item.dataset.variantCompareAt || '0', 10),
        available: true
      };
    });

    function recalculate() {
      var total = 0, compareTotal = 0, allAvailable = true;
      Object.values(itemState).forEach(function (s) {
        total += s.price;
        compareTotal += (s.compareAt > s.price ? s.compareAt : s.price);
        if (!s.available) allAvailable = false;
      });

      if (totalAmountEl) totalAmountEl.textContent = formatMoney(total);

      if (compareTotal > total && compareWrapEl && compareAmountEl) {
        compareAmountEl.textContent = formatMoney(compareTotal);
        compareWrapEl.hidden = false;
      } else if (compareWrapEl) { compareWrapEl.hidden = true; }

      if (installmentsWrapEl && installmentsTextEl && total > 0) {
        var num = Math.min(Math.floor(total / minInstallmentPrice), maxInstallments);
        if (num > 1) {
          installmentsTextEl.textContent = num + 'x de ' + formatMoney(Math.floor(total / num));
          installmentsWrapEl.hidden = false;
        } else { installmentsWrapEl.hidden = true; }
      }

      if (addToCartBtn) addToCartBtn.disabled = !allAvailable;
      if (unavailableNotice) unavailableNotice.hidden = allAvailable;
    }

    bundle.addEventListener('bundle:variant:changed', function (e) {
      var pid = e.detail.productId;
      var state = itemState[pid];
      if (!state) return;

      state.price = e.detail.price || 0;
      state.compareAt = e.detail.compareAtPrice || 0;
      state.available = e.detail.available !== false;
      state.variantId = e.detail.variantId;

      var item = bundle.querySelector('[data-bundle-item][data-product-id="' + pid + '"]');
      if (item) updateCardUI(item, e.detail);

      recalculate();
    });

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        var lineItems = [];
        items.forEach(function (item) {
          var state = itemState[item.dataset.productId];
          if (state && state.variantId) {
            lineItems.push({ id: parseInt(state.variantId, 10), quantity: 1 });
          }
        });
        if (!lineItems.length) return;

        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('ec-bundle__button--loading');

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: lineItems,
            sections: ['cart-drawer', 'cart-icon-bubble']
          })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              console.error('[ec-bundle] Cart error:', data.description || data.message);
              return;
            }

            var cartDrawerEl = document.querySelector('cart-drawer');

            if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function' && data.sections) {
              cartDrawerEl.renderContents({ sections: data.sections });
              return;
            }

            if (data.sections) {
              var drawerHtml = data.sections['cart-drawer'];
              if (drawerHtml) {
                var drawerTarget = document.getElementById('CartDrawer');
                if (drawerTarget) {
                  var parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
                  var inner = parsed.querySelector('#CartDrawer');
                  if (inner) {
                    drawerTarget.innerHTML = inner.innerHTML;
                    var overlay = drawerTarget.querySelector('#CartDrawer-Overlay');
                    if (overlay && cartDrawerEl) overlay.addEventListener('click', cartDrawerEl.close.bind(cartDrawerEl));
                  }
                }
              }
              var iconHtml = data.sections['cart-icon-bubble'];
              if (iconHtml) {
                var iconTarget = document.getElementById('cart-icon-bubble');
                if (iconTarget) {
                  var parsedIcon = new DOMParser().parseFromString(iconHtml, 'text/html');
                  var iconInner = parsedIcon.querySelector('.shopify-section');
                  if (iconInner) iconTarget.innerHTML = iconInner.innerHTML;
                }
              }
            }

            if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
              setTimeout(function () { cartDrawerEl.open(); });
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ec-bundle', cartData: data });
            }
          })
          .catch(function (err) {
            console.error('[ec-bundle] Add to cart failed:', err);
          })
          .finally(function () {
            addToCartBtn.disabled = false;
            addToCartBtn.classList.remove('ec-bundle__button--loading');
            recalculate();
          });
      });
    }

    recalculate();
  }

  function initAll() {
    document.querySelectorAll('[data-ec-bundle]').forEach(function (bundle) {
      initCustomDropdowns(bundle);
      initBundleSummary(bundle);
      initVariantSelects(bundle);
    });
  }

  function observeRecommendations() {
    var rec = document.querySelector('product-recommendations');
    if (!rec) return;
    if (rec._bundleObserved) return;
    rec._bundleObserved = true;
    new MutationObserver(function () {
      setTimeout(initAll, 80);
    }).observe(rec, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); observeRecommendations(); });
  } else {
    initAll();
    observeRecommendations();
  }
})();
